import React from 'react'

function Faqs() {
    return (
        <div>
            Faqs 
        </div>
    )
}

export default Faqs
